import { render, staticRenderFns } from "./SupportNavigation.vue?vue&type=template&id=39d0aa7f&"
import script from "./SupportNavigation.vue?vue&type=script&lang=js&"
export * from "./SupportNavigation.vue?vue&type=script&lang=js&"
import style0 from "./SupportNavigation.vue?vue&type=style&index=0&id=39d0aa7f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports